import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49dd0d5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "reel-slide-progress-bar-bkg" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "reel-slide-progress-bar" }, null, -1))
const _hoisted_3 = { class: "reel-slide-header" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]

import { FontAwesomeIcon } from 'fontawesome/vue-fontawesome'
import { faXmark } from 'fontawesome/free-solid-svg-icons'

interface Props {
    title: string
    message: string
    canShare: boolean
    score: string
    canAddReportCard: boolean
    slideTimeDuration: number
    close: () => void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ReelSlide',
  props: {
    title: {},
    message: {},
    canShare: { type: Boolean },
    score: {},
    canAddReportCard: { type: Boolean },
    slideTimeDuration: {},
    close: { type: Function }
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "5711a55d": (animationDuration),
  "0536aa62": (_unref(leftAdjustment))
}))

const props = __props

const animationDuration = `${props.slideTimeDuration / 1000}s`
const leftAdjustment = props.score?.length === 1 ? '0' : '-70px'

const themeOptions = ['purple', 'pink', 'yellow']
const randomTheme =
    themeOptions[Math.floor(Math.random() * themeOptions.length)]

const animationOptions = [
    'scale-up-anim',
    'tracking-in-anim',
    'focus-in-anim',
    'slide-in-anim',
    'bounce-in-anim',
]
const randomTitleAnimation =
    animationOptions[Math.floor(Math.random() * animationOptions.length)]
const randomMsgAnimation =
    animationOptions[Math.floor(Math.random() * animationOptions.length)]
const randomScoreAnimation =
    animationOptions[Math.floor(Math.random() * animationOptions.length)]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`reel-slide theme-${_unref(randomTheme)}`)
  }, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", {
        class: _normalizeClass(`reel-slide-header-title ${_unref(randomTitleAnimation)}`),
        innerHTML: props.title
      }, null, 10, _hoisted_4),
      _createElementVNode("button", {
        class: "reel-slide-header-close-btn",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (props.close && props.close(...args)))
      }, [
        _createVNode(_unref(FontAwesomeIcon), {
          icon: _unref(faXmark),
          size: "lg"
        }, null, 8, ["icon"])
      ])
    ]),
    _createElementVNode("p", {
      class: _normalizeClass(`reel-slide-message ${_unref(randomMsgAnimation)}`),
      innerHTML: props.message
    }, null, 10, _hoisted_5),
    _createElementVNode("p", {
      class: _normalizeClass(`reel-slide-score ${_unref(randomScoreAnimation)}`)
    }, _toDisplayString(props.score), 3)
  ], 2))
}
}

})